import React from 'react'
import {BrowserRouter as Router} from "react-router-dom";
import RouterApp from '../routes/RouterApp'
import Env from '../config/env'

const AppRouter = () => {

    return (
        <Router basename={`/${Env.DirectoryName}`}>
            <RouterApp/>
        </Router>
    );
}
export default AppRouter